export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><g fill=\"#3F4450\" fill-rule=\"nonzero\"><path d=\"M8.5 4.5h-1v2.997h-3v1h3V11.5h1V8.497h3v-1h-3z\"/><path d=\"M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 15c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z\"/></g></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};